import {
	Button, ButtonTypes, HoverIcon, Popover, PopoverPlacement, PopoverTrigger, TitleBar
} from "@clintonelec/react-storybook";
import { memo } from "react";
import { selectUser } from "Data/Redux/Slices/User";
import { logoutUserAction } from "Data/Redux/Slices/User";
import { clearCacheAction } from "Data/Actions/System";
import "Components/TitleBar/UserPopover/UserPopover.less";
import { useAppDispatch, useAppSelector } from "Data/Redux/Store";
import EditUserModal from "Components/EditUserModal";
import PolicyModal from "Components/Global/PolicyModal";
import { PolicyType } from "Interfaces";

const UserPopover = () => {
	const dispatch = useAppDispatch();
	const user = useAppSelector(selectUser);

	if (!user) {
		return null;
	}

	const logout = () => dispatch(logoutUserAction());
	const clearCache = () => dispatch(clearCacheAction());

	const handleLogout = () => {
		logout();
		clearCache();
	};

	const popoverContent = (
		<div className="user-popover-content-wrapper">
			<div className="user-information">
				<h4>{ user.name }</h4>
				<p>{ user.email }</p>
			</div>
			<div className="account-buttons">
				<EditUserModal user={ user }>
					<Button type={ ButtonTypes.SECONDARY } className="popover-button">
						Manage Account
					</Button>
				</EditUserModal>
				<Button type={ ButtonTypes.SECONDARY } onClick={ handleLogout } className="popover-button">
					Sign Out
				</Button>
			</div>
			<span>Clinton DDNS</span>
			<div className="divider" />
			<div className="legal-pages">
				<PolicyModal policy={ PolicyType.TERMS_AND_CONDITIONS }>Terms &amp; Conditions</PolicyModal>
				<PolicyModal policy={ PolicyType.PRIVACY_POLICY }>Privacy Policy</PolicyModal>
			</div>
		</div>
	);

	return (
		<Popover
			className="user-popover"
			content={ popoverContent }
			trigger={ PopoverTrigger.CLICK }
			placement={ PopoverPlacement.BOTTOM_END }
			arrow={ false }
			appendToBody
		>
			<TitleBar.Button>
				<HoverIcon name="circle-user" />
			</TitleBar.Button>
		</Popover>
	);
};

export default memo(UserPopover);
